
import React,{useState,useEffect} from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

import { locales } from "../constants/locations.js";
import { Route, Routes } from "react-router-dom";
// import PageNotFound from "../components/layout/PageNotFound.jsx";
import Sample from '../pages/Sample.jsx'
import CategorySelection from "../pages/CategorySelection.jsx";
import RaidCapacityCalculator from "../pages/RaidCapacityCalculator.jsx";
import PressRelease from "../pages/PressRelease/PressRelease.jsx";
import Events from "../pages/Events/Events.jsx";
// mainly used for our react app
import SearchSupport from "../pages/SearchSupport/SearchSupport.jsx";
import SearchLanding from "../pages/searchLanding/SearchLanding.jsx";
import NewsRoom from "../pages/NewsRoom/NewsRoom.jsx";
import ResourceLibrary from "../pages/ResourceLibrary/ResourceLibrary.jsx";

function SiteRouting() {
  
  const getlocation = useLocation();
  const [Location, setLocation] = useState("");

  useEffect(() => {
    const loca = getlocation.pathname.split('/')[1];

    if (locales.includes(loca)) {
      i18n.changeLanguage(loca); 
    } else {
      i18n.changeLanguage('en-us'); 
      console.warn(`Invalid location detected: "${loca}", falling back to "${'en-us'}".`);
    }
  }, [getlocation.pathname, i18n]);

  useEffect((props) => {
    const localeArray = locales;
    var currentLocale = localeArray.find((index) => {
      return (
        getlocation.pathname.indexOf("/" + index + "/") !== -1 ||
        getlocation.pathname.indexOf("/" + index) !== -1
      );
    });
    setLocation(currentLocale !== undefined ? "/" + currentLocale : "");
  }, []);
  
  return (
    <Routes>
      <Route path={Location+"/search"} element={<SearchLanding />} />
      <Route path={Location} element={<SearchLanding />} />
      <Route path={Location+'/sample'} element={<Sample />} />
      {/* <Route path="/search-support" element={<SearchSupport />} /> */}
      {/* { <Route path="/support/search-support" element={<SearchSupport />} /> } */}
       <Route path={Location+"/support/search-support"} element={<SearchSupport />} />
      {/* <Route path="/events" element={<Events />} /> */}
      <Route path={Location +"/company/newsroom/:pagetype"} element={<NewsRoom />} />
      <Route path={Location +"/company/newsroom"} element={<NewsRoom />} />
      {/* <Route path={Location+"/support/category-selection"} element={<CategorySelection />} /> */}
      <Route path={Location+"business/support/store/resource-library"} element={<ResourceLibrary />} />
      <Route path={Location+"/support/store/resource-library"} element={<ResourceLibrary />} />
      {/* <Route path={Location+"/newsroom/press-releases"} element={<PressRelease />} /> */}

      {/* <Route path={Location+"/raid-capacity-calculator"} element={<RaidCapacityCalculator />} /> */}
      {/* <Route path={Location + "*"} element={< PageNotFound />} /> */}
    </Routes>
  );
}
export default SiteRouting;
